import React, { useState } from "react";
import "../../style/pages/categoriespage/agents.css";
import { useNavigate } from "react-router-dom";

import Header from "../../component/Header.jsx";

import Filter from "../../component/Filter.jsx";
import ItemGrid from "../../component/ItemGrid.jsx";

import a1 from "../../media3/categories/a1.png";
import a2 from "../../media3/categories/a2.png";
import a3 from "../../media3/categories/a3.png";
import a4 from "../../media3/categories/a4.png";
import a5 from "../../media3/categories/a5.png";
import a6 from "../../media3/categories/a6.png";
import a7 from "../../media3/categories/a7.png";
import a8 from "../../media3/categories/a8.png";
import a9 from "../../media3/categories/a9.png";
import a10 from "../../media3/categories/a10.png";
import a11 from "../../media3/categories/a11.png";
import a12 from "../../media3/categories/a12.png";
import a13 from "../../media3/categories/a13.png";
import a14 from "../../media3/categories/a14.png";
import a15 from "../../media3/categories/a15.png";
import a16 from "../../media3/categories/a16.png";
import a17 from "../../media3/categories/a17.png";
import a18 from "../../media3/categories/a18.png";
import a19 from "../../media3/categories/a19.png";
import a20 from "../../media3/categories/a20.png";
import a21 from "../../media3/categories/a21.png";
import a22 from "../../media3/categories/a22.png";
import a23 from "../../media3/categories/a23.png";
import a24 from "../../media3/categories/a24.png";
import a from "../../media3/categories/a.png";

// Dummy data
export const agentsData = [
  { id: 1, name: "Agent | Slalom", img: a1, price: 61, maxPrice: 122, color: "red", rating: 4, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Elite operative in red Slalom ski gear, dodging fire with alpine agility and precision in high-stakes drops." },
  { id: 2, name: "Agent | Blaze", img: a2, price: 80, maxPrice: 150, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Covert specialist engulfed in blue Blaze flames, burning through enemy lines with unmatched intensity." },
  { id: 3, name: "Agent | Fade", img: a3, price: 95, maxPrice: 160, color: "red", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Tactical agent with red-to-purple Fade camo, blending seamlessly into urban shadows for stealth ops." },
  { id: 4, name: "Agent | Orion", img: a4, price: 120, maxPrice: 180, color: "blue", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "High-tech operative under blue Orion constellation armor, navigating night missions with stellar accuracy." },
  { id: 5, name: "Agent | See Ya Later", img: a5, price: 70, maxPrice: 125, color: "yellow", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Playful agent in yellow 'See Ya Later' gator suit, ambushing foes with mechanical charm and surprise." },
  { id: 6, name: "Agent | Hyper Beast", img: a6, price: 90, maxPrice: 140, color: "orange", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Ferocious operative with orange Hyper Beast exosuit, charging into battle with primal, unstoppable force." },
  { id: 7, name: "Agent | Fuel Injector", img: a7, price: 110, maxPrice: 160, color: "green", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Mechanized agent in green Fuel Injector rig, overcharging combat performance with industrial power." },
  { id: 8, name: "Agent | Melondrama", img: a8, price: 60, maxPrice: 120, color: "green", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Quirky operative in green Melondrama watermelon armor, slicing through tension with fruity, lighthearted flair." },
  { id: 9, name: "Agent | Llama Cannon", img: a9, price: 75, maxPrice: 130, color: "blue", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Explosive agent equipped with blue Llama Cannon launcher, blasting chaos with quirky, heavy firepower." },
  { id: 10, name: "Agent | Kill Confirmed", img: a10, price: 145, maxPrice: 200, color: "red", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Lethal assassin in red Kill Confirmed gear, marked with blood—every mission ends in verified elimination." },
  { id: 11, name: "Agent | Bullet Queen", img: a11, price: 88, maxPrice: 150, color: "blue", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Royal operative in blue Bullet Queen regalia, commanding the battlefield with golden precision and authority." },
  { id: 12, name: "Agent | Handgun", img: a12, price: 55, maxPrice: 110, color: "red", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Compact agent in red Handgun tactical vest, mastering close-quarters with pistol proficiency and speed." },
  { id: 13, name: "Agent | Avalanche", img: a13, price: 68, maxPrice: 125, color: "red", rating: 4, rarity: "Restricted", orderedBy: "Newest", currency: "USD", description: "Winter operative in red Avalanche insulated suit, charging through blizzards with unstoppable momentum." },
  { id: 14, name: "Agent | Xiangliu", img: a14, price: 92, maxPrice: 160, color: "black", rating: 4, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Mythical agent in black Xiangliu serpent armor, striking silently with multi-headed venom and agility." },
  { id: 15, name: "Agent | Muertos", img: a15, price: 63, maxPrice: 120, color: "black", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Festive operative in black Muertos Day of the Dead attire, fighting with cultural pride and fearless spirit." },
  { id: 16, name: "Agent | Angry Mob", img: a16, price: 85, maxPrice: 140, color: "black", rating: 5, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Rebellious agent in black Angry Mob riot gear, leading uprisings with crowd-fueled chaos and power." },
  { id: 17, name: "Agent | Cobra Strike", img: a17, price: 78, maxPrice: 130, color: "red", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Stealth operative in red Cobra Strike suit, delivering venomous, lightning-fast strikes from the shadows." },
  { id: 18, name: "Agent | Crazy 8", img: a18, price: 59, maxPrice: 110, color: "purple", rating: 2, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Unpredictable agent in purple Crazy 8 dice outfit, gambling on luck and wild, chaotic tactics." },
  { id: 19, name: "Agent | Ticket to Hell", img: a19, price: 99, maxPrice: 160, color: "black", rating: 5, rarity: "Classified", orderedBy: "Price", currency: "USD", description: "Demonic operative in black Ticket to Hell armor, burning through enemies with infernal rage and power." },
  { id: 20, name: "Agent | Water Elemental", img: a20, price: 115, maxPrice: 175, color: "green", rating: 5, rarity: "Covert", orderedBy: "Newest", currency: "USD", description: "Mystical agent in green Water Elemental suit, flowing through combat with fluid, unstoppable grace." },
  { id: 21, name: "Agent | Asiimov", img: a21, price: 102, maxPrice: 155, color: "green", rating: 4, rarity: "Classified", orderedBy: "Rating", currency: "USD", description: "Futuristic operative in green Asiimov exosuit, executing high-tech missions with geometric precision." },
  { id: 22, name: "Agent | Pole Position", img: a22, price: 66, maxPrice: 125, color: "orange", rating: 3, rarity: "Restricted", orderedBy: "Popularity", currency: "USD", description: "Racing-themed agent in orange Pole Position gear, speeding into action with track-ready reflexes." },
  { id: 23, name: "Agent | Isaac", img: a23, price: 74, maxPrice: 130, color: "white", rating: 4, rarity: "Classified", orderedBy: "Newest", currency: "USD", description: "Cyber agent in white Isaac holographic armor, hacking reality with advanced tech and tactical brilliance." },
  { id: 24, name: "Agent | Boost Protocol", img: a24, price: 97, maxPrice: 160, color: "purple", rating: 5, rarity: "Covert", orderedBy: "Price", currency: "USD", description: "Overclocked operative in purple Boost Protocol suit, pushing human limits with cybernetic speed and power." }
];
const colors = ["red", "green", "blue", "yellow", "purple", "black", "white", "orange"];
const ratings = [5, 4, 3, 2, 1];

function Agents({ isLoggedIn, setLoginModalOpen, handleLogout }) {
  const [priceRange, setPriceRange] = useState([50, 200]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedRating, setSelectedRating] = useState(null);
  const [openFilter, setOpenFilter] = useState("Price");
   const [selectedRarity, setSelectedRarity] = useState(null);
  const [selectedOrderBy, setSelectedOrderBy] = useState(null);

  const navigate = useNavigate();

  // Filtering
  // const filteredAgents = agentsData.filter((item) => {
  //   const inPrice = item.price >= priceRange[0] && item.price <= priceRange[1];
  //   const inColor = selectedColors.length === 0 || selectedColors.includes(item.color);
  //   const inRating = !selectedRating || item.rating === selectedRating;
  //   return inPrice && inColor && inRating;
  // });

    let filteredAgents = agentsData.filter((pistol) => {
    const inPrice = pistol.price >= priceRange[0] && pistol.price <= priceRange[1];
    const inColor = selectedColors.length === 0 || selectedColors.includes(pistol.color);
    const inRating = !selectedRating || pistol.rating === selectedRating;
    const inRarity = !selectedRarity || selectedRarity === "Any" || pistol.rarity === selectedRarity;
    return inPrice && inColor && inRating && inRarity;
  });
  
  // Add sorting
  if (selectedOrderBy) {
    filteredAgents = [...filteredAgents].sort((a, b) => {
      switch (selectedOrderBy) {
        case "Price":
          return a.price - b.price;
        case "Rating":
          return b.rating - a.rating;
        case "Popularity":
          return a.id - b.id;
        case "Newest":
          return b.id - a.id;
        default:
          return 0;
      }
    });
  }
  
  const handleRarityChange = (rarity) => {
    setSelectedRarity(rarity === selectedRarity ? null : rarity);
  };
  
  const handleOrderByChange = (orderBy) => {
    setSelectedOrderBy(orderBy === selectedOrderBy ? null : orderBy);
  };

  // Handlers
  const handlePriceChange = (e, idx) => {
    const newRange = [...priceRange];
    newRange[idx] = Number(e.target.value);
    setPriceRange(newRange);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };

  const handleRatingChange = (rating) => {
    setSelectedRating(rating === selectedRating ? null : rating);
  };

    const handleNavigate = (itemName) => {
    navigate(`/items/${encodeURIComponent(itemName)}`);
  };

  const toggleSection = (section) => {
    setOpenFilter(openFilter === section ? "" : section);
  };

  return (
    <div className="categories-page">
             <Header
        isLoggedIn={isLoggedIn}
        setLoginModalOpen={setLoginModalOpen}
        handleLogout={handleLogout}
      />
      <div className="categories-content">
                <Filter
          openFilter={openFilter}
          toggleSection={toggleSection}
          priceRange={priceRange}
          handlePriceChange={handlePriceChange}
          selectedColors={selectedColors}
          handleColorChange={handleColorChange}
          selectedRating={selectedRating}
          handleRatingChange={handleRatingChange}
          colors={colors}
          ratings={ratings}
                    selectedRarity={selectedRarity}
  handleRarityChange={handleRarityChange}
  selectedOrderBy={selectedOrderBy}
  handleOrderByChange={handleOrderByChange}
        />
        <ItemGrid
          items={filteredAgents}
          categoryImage={a}
          categoryAlt="CZ75-Auto"
          categoryTitle="Agent | Crazy 8"
          categoryDescription="Step into battle with the most iconic CS2 agents, each designed with personality and precision.
From legendary operatives to elite specialists, every agent tells a story of style and skill.
Assemble your squad, showcase your favorites, and bring your unique flair to the battlefield.
Collect, customize, and command your agents — making every match a statement of identity."
          onItemClick={handleNavigate}
            isLoggedIn={isLoggedIn}                   
          setLoginModalOpen={setLoginModalOpen}
        />
      </div>
    </div>
  );
}

export default Agents;